module.exports = __webpack_public_path__ + "0b4a5d2570e82e1e8ce28d14c70c335d.png";